import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { supabase } from '../../lib/supabaseClient';

interface Props { isOpen: boolean; onClose: () => void; }

export default function ResetPasswordModal({ isOpen, onClose }: Props) {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  if (!isOpen) return null;

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setSubmitting(true);
    setMessage(null);
    setError(null);
    try {
      const redirectTo = `${window.location.origin}/reset-password`;
      const { error } = await supabase.auth.resetPasswordForEmail(email, { redirectTo });
      if (error) throw error;
      setMessage(t('auth.resetSent'));
    } catch (err: any) {
      setError(t('auth.resetError'));
      try { console.error('[auth] reset email error', err); } catch {}
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="fixed inset-0 z-50 flex min-h-screen items-center justify-center bg-black/70 backdrop-blur-sm p-4 sm:p-6" role="dialog" aria-modal="true" aria-labelledby="reset-modal-title">
      <div className="w-full max-w-sm sm:max-w-md bg-gray-900 rounded-lg sm:rounded-xl shadow-2xl border border-pink-600/20">
        <div className="flex items-center justify-between px-5 sm:px-6 py-4 border-b border-gray-800">
          <h3 id="reset-modal-title" className="text-lg font-semibold text-white">{t('auth.resetTitle')}</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-white px-2 py-1 rounded">✕</button>
        </div>
        <div className="p-5 sm:p-6 space-y-3 text-gray-300">
          <p className="text-sm text-gray-400">{t('auth.resetDescription')}</p>
          <form onSubmit={handleSubmit} className="space-y-3">
            <label htmlFor="reset-email" className="block text-sm text-gray-300">{t('auth.email')}</label>
            <input id="reset-email" name="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} type="email" required className="w-full rounded-md bg-black/40 border border-gray-700 px-3 py-2 text-white" />
            <button disabled={submitting} className="w-full bg-pink-600 hover:bg-pink-700 disabled:opacity-50 text-white font-semibold rounded-md py-2 mt-2">{t('auth.resetSend')}</button>
          </form>
          {message && <p className="text-sm text-green-400">{message}</p>}
          {error && <p className="text-sm text-red-400">{error}</p>}
        </div>
      </div>
    </div>
  );
}


